import React from "react";
import { GoogleReviews } from "@/components/sections/HomeSections";

export default function Reviews() {
  return (
    <div data-testid="reviews-page" className="pt-32">
      <section className="section-pad pb-0 max-w-[1400px] mx-auto text-center">
        <div className="eyebrow">Reviews</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light mt-4 tracking-tight">What Our <em className="text-[#D4AF37] not-italic">Couples Say</em></h1>
      </section>
      <GoogleReviews />
    </div>
  );
}
